/**
 * Read-only brand/model value for the ENG-4832 C3 state: the camera is not in
 * the catalogue, so the step shows Brand "Not listed" and the typed model in
 * place of the search fields. Styled like the input it stands in for.
 *
 * A plain `<button>` (not the design-system Button) keeps the optional
 * "Change" action free of the Button test doubles the step suites install.
 * Per rule: playwright-stag-selectors-only (ai.knowledge/platform) — "Change"
 * carries the `not-listed:change` STag.
 */
import { Sel, STag } from '#~/stag/tag.js';
import type { ReactElement } from 'react';

/** Brand shown in the C3 state. */
export const NotListedBrandLabel = 'Not listed';

/** `<ReadOnlyValue>` properties. */
export interface ReadOnlyValueProps {
  /** Text shown. */
  value: string;

  /** When given, renders a "Change" action (reopens the not-listed flow). */
  onChange?: (() => void) | undefined;
}

/** `<ReadOnlyValue>` component. */
export const ReadOnlyValue = ({ onChange, value }: ReadOnlyValueProps): ReactElement => (
  <div className='flex h-34 items-center justify-between gap-8 rounded bg-base-100 px-12 text-md'>
    <span aria-readonly='true' className='truncate text-secondary'>
      {value}
    </span>
    {onChange && (
      <button
        className='text-sm text-primary underline'
        onClick={onChange}
        type='button'
        {...STag(Sel.ConfigVideoDeviceBrandModel, 'not-listed', 'change')}
      >
        Change
      </button>
    )}
  </div>
);
